import { HttpHeadersPayload } from '../api-builder/models/common.interfaces';
import { Config } from './config.interfaces';

export interface GenericPage<T> {
  backgroundImage: string;
  header: Partial<GenericContent>;
  content: T;
  footer: Partial<GenericContent>;
}

export interface GenericContent {
  title: string;
  subtitle: string;
  content: string;
  message?: string;
  description?: string;
}

export interface GenericOptionsList<T> {
  title: string;
  options: T[];
}

export interface GenericOption {
  code: string;
  description: string;
}

export interface GenericFormObject {
  [key: string]: string | number | boolean | null;
}

export interface GenericLabel {
  title: string;
  subtitle: string;
}

export interface GenericQueryParamRequest {
  payload: Config;
  headerInfo: HttpHeadersPayload;
}

export interface GenericFormContent<T> {
  instructions: string;
  sections: T[];
  actions: string[];
}
